module.exports = __webpack_public_path__ + "images/banners/happy-team.b92f7d7e6fa25909db6c.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/banners/happy-team.svg
// module id = hUE3
// module chunks = 24